import { render } from "./Howitworks.vue?vue&type=template&id=c1ac5a70&scoped=true"
import script from "./Howitworks.vue?vue&type=script&lang=js"
export * from "./Howitworks.vue?vue&type=script&lang=js"

import "./Howitworks.vue?vue&type=style&index=0&id=c1ac5a70&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c1ac5a70"]])

export default __exports__